import PropTypes from 'prop-types'

import { FlexColumn } from '../styles/Containers'
import FormInput from '../inputFields/FormInput'
import RichTextEditor from '../inputFields/RichTextEditor'
import LetterTemplateHeader from '../letterTemplates/LetterTemplateHeader'

function LetterForm({ disabled = false, isTemplate = false }) {
  return (
    <FlexColumn gap="20px">
      <FormInput id="name" label="Name" disabled={disabled} />
      {isTemplate && <LetterTemplateHeader />}
      <RichTextEditor disabled={disabled} />
    </FlexColumn>
  )
}

LetterForm.propTypes = {
  disabled: PropTypes.bool,
  isTemplate: PropTypes.bool
}

export default LetterForm
